import React from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { fetchApi, General, makeResetCache, notifyError, notifyResponse } from 'gossamer-front-end';
import { AdminChangeEventLocationRequest, Event } from 'cb-model';
import { cloneField } from 'gossamer-unified';

interface EventLocationChangeModalProps {
  eventId: number;
  locationType: string;
  location: string;
  show: boolean;
  setShow: (val: boolean) => void;
}

export const EventChangeLocationModal = (props: EventLocationChangeModalProps) => {
  const [locationType, setLocationType] = React.useState(props.locationType);
  const [location, setLocation] = React.useState(props.location);
  const [processing, setProcessing] = React.useState(false);
  const dispatch = useDispatch();
  const resetCache = makeResetCache(dispatch);
  const locationField = cloneField(Event.fields.location);

  React.useEffect(() => {
    if (locationType === 'online') {
      locationField.mandatory = false;
      setLocation('');
    } else {
      locationField.mandatory = true;
    }
  }, [locationType]);

  React.useEffect(() => {
    setLocationType(props.locationType);
    setLocation(props.location);
  }, [props.show]);

  const handleSave = async () => {
    if (locationType !== 'online' && !location) {
      return;
    }
    setProcessing(true);
    try {
      const response = await fetchApi('POST', `/main/event-location-change`, {
        eventId: props.eventId,
        locationType,
        location,
      } as AdminChangeEventLocationRequest);
      resetCache(Event.id, String(props.eventId));
      notifyResponse(response);
      props.setShow(false);
    } catch (e) {
      notifyError(e, 'An error occurred while changing the event location');
    }
    setProcessing(false);
  };
  return (
    <Modal
      show={props.show}
      onHide={() => props.setShow(false)}
      aria-labelledby="event-location-change-modal-title"
      size="sm"
      fullscreen="md-down"
    >
      <Modal.Header closeButton>
        <Modal.Title id="event-location-change-modal-title">Change Location</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <General
            editable={true}
            fieldId="location_type"
            field={Event.fields.location_type}
            value={locationType}
            handleChange={setLocationType}
          />
          <br />
          {locationType !== 'online' && <div>In-person location:</div>}
          <General
            editable={locationType !== 'online'}
            fieldId="location"
            field={locationField}
            value={location}
            handleChange={setLocation}
            validity={locationType === 'online' || !!location}
          />
          <br />
          <Button variant="primary" onClick={handleSave} disabled={processing}>
            Save
          </Button>
          <br />
        </Form>
      </Modal.Body>
    </Modal>
  );
};
